import { defineStore } from 'pinia';

export const useModeStore = defineStore('mode', {
    state: () => ({
        currentMode: null as 'hifi' | 'studio' | 'all' | null,
        modeData: {
            hifi: null,
            studio: null,
            all: null,
        }
    }),
    actions: {
        setMode(mode: 'hifi' | 'studio' | 'all') {
            this.currentMode = mode;
        },
        setModeData(mode: 'hifi' | 'studio' | 'all' ,data:any) {
            this.modeData[mode] = data;
        }
    }
});
